import { orderBy, query } from "firebase/firestore";
import getPushesRef from "./getPushesRef";

const getPushesQuery = () => {
  return query(getPushesRef(), orderBy('createdAt', 'desc'));
}

export default getPushesQuery;